export const RECEIPT_STEPS = {
  ADDED: "ADICIONADO",
  INACTIVATED: "INATIVOU", 
  ACTIVATED: "ATIVOU", 
};

export const RECEIPT_STEPS_TRANSKEY = {
  [RECEIPT_STEPS.ADDED]: 'Comprovante adicionado a NF',
  [RECEIPT_STEPS.INACTIVATED]: 'Comprovante inativado', 
  [RECEIPT_STEPS.ACTIVATED]: 'Comprovante reativado'
};
